import { apiCall } from "../../services/api-service";

export const getInspectionListApi = (params) =>
  apiCall("get", `inspection?${params}`);

export const getInspectionEditDetailsApi = (id) =>
  apiCall("get", `inspection/edit/${id}`);

export const getVehicleDetailsApi = (id) =>
  apiCall("get", `get_vehicle_details/${id}`);

export const submitInspectionAPI = (body) =>
  apiCall("post", "inspection", body);

export const updateInspectionAPI = (id, body) =>
  apiCall("put", `inspection/${id}`, body);

export const getInspectionDetailsApi = (id) =>
  apiCall("get", `inspection/view/${id}`);

export const getInspectionHistoryDetailsApi = (id) =>
  apiCall("get", `inspection_history/${id}`);

export const saveAttachmentApi = (id, body) =>
  apiCall("put", `inspection/add_attachment/${id}`, body);

export const getInspectionEditApi = (id) =>
  apiCall("get", `inspection/edit/${id}`);

export const getInspectionHistoryListApi = (id) =>
  apiCall("get", `inspection_history_list/${id}`);
